
import React from "react";
import { format } from "date-fns";
import { nl } from "date-fns/locale";

const DamageReportHeader: React.FC = () => {
  const currentDate = format(new Date(), "EEEE d MMMM yyyy", { locale: nl });
  
  return (
    <div className="border-b pb-4">
      <h1 className="text-2xl font-bold">📊 Schadeanalyse Luijten VVZ & Decoprof – Q2 2025, Periode 3</h1>
      <p className="text-muted-foreground">📅 Datum rapport: {currentDate}</p>
      <p className="text-muted-foreground">📁 Datasetomvang: 31 schadegevallen</p>
    </div>
  );
};

export default DamageReportHeader;
